import { apiClient } from '@/utils/api';

export interface DefaultActivity {
  type: string; // Tipo dinamico dal database
  daysOffset: number;
  priority?: 'LOW' | 'MEDIUM' | 'HIGH' | 'URGENT';
}

export interface DefaultAppointment {
  daysOffset: number;
}

export interface PracticeType {
  id: string;
  name: string;
  code: string;
  description?: string;
  icon?: string;
  color?: string;
  isActive: boolean;
  isDefault: boolean;
  order: number;
  defaultActivities?: DefaultActivity[] | null;
  defaultAppointments?: DefaultAppointment[] | null;
  folderParentTemplate?: string | null;
  folderSubfolders?: string[] | null;
  createdAt: string;
  updatedAt: string;
  _count?: {
    practices: number;
  };
}

export const practiceTypeService = {
  async getPracticeTypes(activeOnly: boolean = true) {
    const response = await apiClient.get(`practice-types`, {
      params: { activeOnly: activeOnly.toString() },
    });
    return response.data;
  },

  async getPracticeType(id: string) {
    const response = await apiClient.get(`practice-types/${id}`);
    return response.data;
  },

  async createPracticeType(data: Partial<PracticeType>) {
    const response = await apiClient.post(`practice-types`, data);
    return response.data;
  },

  async updatePracticeType(id: string, data: Partial<PracticeType>) {
    const response = await apiClient.put(`practice-types/${id}`, data);
    return response.data;
  },

  async deletePracticeType(id: string) {
    const response = await apiClient.delete(`practice-types/${id}`);
    return response.data;
  },

  async reorderPracticeTypes(order: { id: string; order: number }[]) {
    const response = await apiClient.put(`practice-types/reorder`, { order });
    return response.data;
  },
};

